module.exports = __webpack_public_path__ + "media/images/hero_images/security-1500-a1d1549a3ff893df7cdae22bd564d3be.png";